import { values } from "lodash"
import PropTypes from "prop-types"
import moment from "moment"
import { BASE_TYPES } from "helpers/base"
import { DATE } from "helpers/shapes"
import { ACTIONS, STATUSES } from "./constants"

export const RESOURCE = PropTypes.shape({
  alias: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["PORTFOLIO"]).isRequired,
  name: PropTypes.string.isRequired,
  updatedAt: PropTypes.string,
})

export const SUMMARY = PropTypes.shape({
  summary: PropTypes.object,
  timestamp: TIMESTAMP,
  error: PropTypes.string,
})

export const BASE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(values(BASE_TYPES)).isRequired,
  experimentId: PropTypes.string,
})

export const BUTTONS = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  Icon: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}))

export const ACTION = PropTypes.oneOf(values(ACTIONS))

// Common prop shapes for AI Summary components
export const MODEL = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
})

export const DATE_RANGE = PropTypes.shape({
  startDate: DATE,
  endDate: DATE,
  showDateRange: PropTypes.bool,
})

export const SUMMARY_STATE = PropTypes.shape({
  summary: PropTypes.object,
  summaryKey: PropTypes.string,
  timestamp: PropTypes.instanceOf(moment),
  error: PropTypes.string,
  status: PropTypes.oneOf(values(STATUSES)),
  thumb: PropTypes.oneOf(["positive", "negative"]),
})

export const SUMMARY_STATES = PropTypes.shape({
  [ACTIONS.SIMULATOR_SUMMARY]: SUMMARY_STATE,
  [ACTIONS.SECURITY_SUMMARY]: SUMMARY_STATE,
  [ACTIONS.ANALYZE_FACTORS_SUMMARY]: SUMMARY_STATE,
  [ACTIONS.FACTOR_SUMMARY]: SUMMARY_STATE,
})

export const TAB_PROPS = PropTypes.shape({
  action: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  activeTab: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  summaryState: SUMMARY_STATE,
})

export const BUTTON_PROPS = PropTypes.shape({
  title: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isGenerated: PropTypes.bool.isRequired,
})

export const TIMESTAMP = PropTypes.instanceOf(moment)

export const HEADER_PROPS = PropTypes.shape({
  headerButtons: BUTTONS,
  isGenerated: PropTypes.bool,
  timestamp: TIMESTAMP,
  resource: RESOURCE.isRequired,
  model: MODEL.isRequired,
  startDate: DATE,
  endDate: DATE,
  showDateRange: PropTypes.bool,
  base: BASE,
})

export const TABS_PROPS = PropTypes.shape({
  headerButtons: BUTTONS,
  setShowDateRange: PropTypes.func.isRequired,
  setCurrentSummaryAction: PropTypes.func.isRequired,
  getSummaryButtons: PropTypes.func.isRequired,
  summaryStates: SUMMARY_STATES.isRequired,
  extraParameters: EXTRA_PARAMETERS,
  resource: RESOURCE.isRequired,
})

export const SIMULATE_ACTION = PropTypes.shape({
  tradeSecurity: PropTypes.shape({
    id: PropTypes.shape({
      ticker: PropTypes.string,
      mic: PropTypes.string,
      bloombergTicker: PropTypes.string,
      figi: PropTypes.string,
      internalId: PropTypes.string,
    }).isRequired,
    operation: PropTypes.shape({
      setEconomicExposure: PropTypes.number,
      setPercentEquity: PropTypes.number,
      setActivePercentEquity: PropTypes.number,
    }).isRequired,
  }),
})

export const ANALYTICS_OUTPUT = PropTypes.shape({
  segment: PropTypes.object,
  expand: PropTypes.bool,
  base: PropTypes.oneOfType([
    BASE,
    PropTypes.oneOf([null]),
  ]),
})

export const EXTRA_PARAMETERS = PropTypes.shape({
  attributionMethod: PropTypes.oneOf(["MCAR", "MCTE"]),
  actions: PropTypes.arrayOf(SIMULATE_ACTION),
  actionsBase: BASE,
  batchId: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  analyticsOutput: ANALYTICS_OUTPUT,
})
